<div class="frac-details" *ngIf="frac$ | async as frac; else loading">
  <nav mat-tab-nav-bar>
    <a
      mat-tab-link
      *ngFor="let link of navLinks$ | async; trackBy: trackByLabel"
      [routerLink]="link.path"
      routerLinkActive
      #rla="routerLinkActive"
      [active]="rla.isActive"
      [disabled]="link.disabled || false"
    >
      <div class="label-wrap">
        <span class="label">{{ link.label }}</span>
        <!--        <span class="sub-label">{{ link.line1 }}</span>-->
        <!--        <span class="sub-label">{{ link.line2 }}</span>-->
      </div>
      <!--<ng-container *ngIf="link.warning">
        <mat-icon
          class="warning"
          [matTooltip]="link.warning"
          matTooltipClass="lmo-warning-tooltip"
          matTooltipPosition="after"
          >warning
        </mat-icon>
      </ng-container>-->
    </a>
    <ng-container *saAllowedAccountRoles="['admin', 'dispatcher']">
      <a
        mat-tab-link
        *ngIf="optedInToNewBillingPortal; else optedOut"
        [routerLink]="['/', 'invoicing', 'orders_list', 'waiting_for_ticket_approval']"
        [queryParams]="{ fracIds: frac.id }"
        saAutomatedSelector="frac_detail__billing_tab"
        class="hide-handheld"
      >
        <div class="label-wrap">
          <span class="label">Billing</span>
          <!--          <span class="sub-label"></span>-->
          <!-- spacers to get this to align with the other tab labels -->
          <!--          <span class="sub-label"></span>-->
        </div>
      </a>
      <ng-template #optedOut>
        <a
          mat-tab-link
          [routerLink]="['/', 'fracs', frac.id, 'orders', 'needDataForTicketing']"
          saAutomatedSelector="frac_detail__billing_tab"
          class="hide-handheld"
        >
          <div class="label-wrap">
            <span class="label">Billing →</span>
          </div>
        </a>
      </ng-template>
    </ng-container>
    <div class="spacer"></div>
    <span
      class="non-tab-link hide-handheld"
      *saAllowedAccountRoles="['admin', 'dispatcher']"
      (click)="downloadRecords()"
      >Download XLSX</span
    >
    <ng-container *ngIf="bolExportOkay">
      <span class="non-tab-link hide-handheld" (click)="startBolExport()" *saFeatureFlag="'bolBulkExport'"
        >Export BOL Images</span
      >
    </ng-container>
    <ng-container *saAllowedAccountRoles="['admin', 'dispatcher', 'default']">
      <a
        class="non-tab-link hide-handheld last-non-tab-link"
        [routerLink]="['/', 'wells', 'edit', frac.id]"
        saAutomatedSelector="well__edit"
        >Edit Well</a
      >
    </ng-container>
    <!-- <span class="nav-icon-wrap">
      <span class="nav-icon nav-icon-active">
        <mat-icon>notifications_none</mat-icon>
      </span>
    </span> -->
  </nav>
  <div class="flex-1 overflow-auto frac-detail-component">
    <router-outlet></router-outlet>
  </div>
</div>
<ng-template #loading>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
<ng-template #bulkBolImageExport>
  <div matDialogTitle>Bulk Export BOL Images</div>
  <div matDialogContent class="flex flex-col">
    <div>
      Select your date range (max 1 week)
    </div>
    <mat-form-field class="flex-1 mr-1">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="startPicker" [formControl]="bolImageExportStartDateFC" />
      <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
      <mat-datepicker #startPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="flex-1 mr-1">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="endPicker" [formControl]="bolImageExportEndDateFC" />
      <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
      <mat-datepicker #endPicker></mat-datepicker>
    </mat-form-field>
    <div *ngIf="(validRange$ | async) === false" class="p-2 border border-red-501 rounded text-red-501">
      Maximum export range is 1 week
    </div>
  </div>
  <div matDialogActions class="flex justify-between">
    <button mat-button matDialogClose>Nevermind</button>
    <button
      mat-button
      mat-stroked-button
      color="primary"
      matDialogClose
      [disabled]="(validRange$ | async) === false"
      (click)="doBolExport()"
    >
      Export
    </button>
  </div>
</ng-template>
